/**
 * Developer mode logger utility.
 * All logging is disabled in production builds (__DEV__ === false).
 */

const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : __DEV__;

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args: any[]) => {
    if (isDev) console.info(...args);
  },
  debug: (...args: any[]) => {
    if (isDev) console.debug(...args);
  },
};

/**
 * Suppress all console output in production builds.
 * Call this once at app startup.
 */
export function setupProductionLogging() {
  if (!isDev) {
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    // Keep console.error for crash reporting / monitoring
  }
}
